import React from 'react'
import { Link } from 'react-router-dom'
import ThemeSF from '../components/common/ThemeSF'
import TopNavLinkUI from '../widgets/output/TopNavLinkUI'
import './HeaderRight.css'

const SuperUserHeaderRightUI = ({ context, topnav, showStp, onShowStpClick, onTypeChange }) =>
  <div className='t_hdr_rgt g_flex_h'>
    {/* <div>
      {
        onTypeChange && ['stp', 'classic'].filter(filter => filter !== context.filter).map((filter, i) =>
          <Link key={i} className='com_filter w_badge'
            to='#' data-filter={filter} onClick={onShowStpClick}>
            {filter === 'stp' ? 'Classic' : 'STP'}
          </Link>
        )
      }
    </div> */}
    <TopNavLinkUI label='Lead Dashboard' to='/su/leadDashboard' active={topnav === 'leadDashboard'} />
    <TopNavLinkUI label='Accounts' to='/su/accounts' active={topnav === 'accounts'} />
    <TopNavLinkUI label='Loans' to='/su/loans' active={topnav === 'loans'} />
    <TopNavLinkUI label='Transactions' to='/su/txns/pending' active={topnav === 'transactions'} />
    {/* <TopNavLinkUI label='Chats' to='/su/allchats' active={topnav === 'chats'} /> */}
    <TopNavLinkUI label='Settings' to='/su/settings' active={topnav === 'settings'} />
    <ThemeSF context={context} />
  </div>

export default SuperUserHeaderRightUI
